import { useFarbweltConfig } from "@/contexts/classified";
import { FarbweltTextColor } from "@/types";
import { useTokens } from "@gemini/core";
export const useFarbwelt = () => {
    const farbweltConfig = useFarbweltConfig();
    const tokens = useTokens();
    const defaultColor = tokens["color.surface.light.default"];
    const defaultBorderColor = tokens["color.border.surface.default"];
    if (!farbweltConfig ||
        (typeof farbweltConfig === "object" &&
            Object.keys(farbweltConfig).length === 0)) {
        return {
            isFarbweltActive: false,
            hasFarbweltTeasers: false,
            showFarbweltBanner: false,
        };
    }
    const { color, logo, teasers, textColor, providerName } = farbweltConfig;
    const hasFarbweltTeasers = (teasers && Object.keys(teasers).length !== 0) || false;
    const getColorToken = (color) => {
        switch (color) {
            case FarbweltTextColor.light:
                return tokens["color.content.default.inverted.default"]; // white
            case FarbweltTextColor.dark:
                return tokens["color.content.active.default"]; // black
            default:
                return tokens["color.content.active.default"]; // default to black
        }
    };
    const bgColor = color || defaultColor;
    const borderColor = color || defaultBorderColor;
    const fallbackTextColor = !logo && !color;
    // If the user picks the default White as Farbwelt color, then we will have trouble rendering the Banner
    // (white over white isn't that great)
    // So we  do not show the banner in that case
    // Color is mandatory for Farbwelt banner functionality in contact card or sticky header https://avivgroup.atlassian.net/browse/TSCN-147
    const showFarbweltBanner = bgColor !== "#FFFFFF";
    return {
        bgColor,
        teasers,
        logo,
        isFarbweltActive: true,
        showFarbweltBanner,
        hasFarbweltTeasers,
        providerName,
        borderColor,
        textColor: fallbackTextColor
            ? getColorToken("")
            : getColorToken(textColor),
    };
};
